import { toast } from "react-toastify";
import { call, put, takeLatest, select } from "redux-saga/effects";
import { actions } from "..";
import { makeAllObjToArr, objToArr } from "../../helpers";
import { orderInvoicesServices } from "../../services";
import { showNotificationWithTimeout } from "../actions/toastActions";
import * as actionTypes from "../actionTypes";

function* getCustomersData(action) {
  const res = yield call(
    orderInvoicesServices.getCustomersData,
    action.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    console.log(data, "actionactionactionaction");
    yield put(
      actions.saveOrderInvoicesValue({ customersData: makeAllObjToArr(data) })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* postCustomersData(action) {
  const res = yield call(
    orderInvoicesServices.postCustomersData,
    action.payload?.formData
  );

  if (res?.status && res?.data) {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "success")
    );
    action.payload.history.push("/order/customers");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getDownloadCustomersData(action) {
  const res = yield call(
    orderInvoicesServices.getDownloadCustomersData,
    action.payload
  );

  if (res?.status && res?.data) {
    const downloadFile = res?.data?.download_file;
    window.open(downloadFile, "_self");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getCustomersFormOptions(action) {
  const res = yield call(
    orderInvoicesServices.getCustomersFormOptions,
    action.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        customerFormOptions: makeAllObjToArr(data),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getCustomerEditData(action) {
  const res = yield call(
    orderInvoicesServices.getCustomerEditData,
    action.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        customerEditData: makeAllObjToArr(data, "customer"),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* postCustomerEditData(action) {
  const res = yield call(
    orderInvoicesServices.postCustomerEditData,
    action.payload?.formData
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        customersData: makeAllObjToArr(data),
      })
    );
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "success")
    );
    action.payload.history.push("/order/customers");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getCustomersFormContactStates(action) {
  const res = yield call(
    orderInvoicesServices.getCustomersFormContactStates,
    action.payload
  );
  const orderInvoicesReducer = yield select(
    (state) => state?.orderInvoicesReducer
  );
  const formType = action.payload.formType;
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      formType === "edit"
        ? actions.saveOrderInvoicesValue({
            customerEditData: makeAllObjToArr({
              ...orderInvoicesReducer.customerEditData,
              address_states: data?.states,
            }),
          })
        : actions.saveOrderInvoicesValue({
            customerFormOptions: makeAllObjToArr({
              ...orderInvoicesReducer.customerFormOptions,
              address_states: data?.states,
            }),
          })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getCustomersFormBillingStates(action) {
  const res = yield call(
    orderInvoicesServices.getCustomersFormBillingStates,
    action.payload
  );
  const orderInvoicesReducer = yield select(
    (state) => state?.orderInvoicesReducer
  );
  const formType = action.payload.formType;
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      formType === "edit"
        ? actions.saveOrderInvoicesValue({
            customerEditData: makeAllObjToArr({
              ...orderInvoicesReducer.customerEditData,
              billing_states: data?.states,
            }),
          })
        : actions.saveOrderInvoicesValue({
            customerFormOptions: makeAllObjToArr({
              ...orderInvoicesReducer.customerFormOptions,
              billing_states: data?.states,
            }),
          })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* postCustomerFile(action) {
  const res = yield call(
    orderInvoicesServices.postCustomerFile,
    action.payload
  );

  if (res?.status && res?.data) {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "success")
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getPayeeList(action) {
  const res = yield call(orderInvoicesServices.getPayeeList, action.payload);

  if (res?.status && res?.data) {
    const data = res.data;
    yield put(actions.saveOrderInvoicesValue({ payeeList: data }));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getDownloadPayeeList(action) {
  const res = yield call(
    orderInvoicesServices.getDownloadPayeeList,
    action.payload
  );

  if (res?.status && res?.data) {
    const data = res.data;
    window.open(data?.download_file);
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* postUploadPayeeList(action) {
  const res = yield call(
    orderInvoicesServices.postUploadPayeeList,
    action.payload
  );

  if (res?.status && res?.data) {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "success")
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getAddPayeeData(action) {
  const res = yield call(orderInvoicesServices.getAddPayeeData, action.payload);

  if (res?.status && res?.data) {
    yield put(
      actions.saveOrderInvoicesValue({
        addEditPayeeData: makeAllObjToArr(res?.data),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* postAddPayeeData(action) {
  const res = yield call(
    orderInvoicesServices.postAddPayeeData,
    action.payload.data
  );

  if (res?.status && res?.data) {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "success")
    );
    action.payload.history.push("/order/payees");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getPayeeLinkedEmployee(action) {
  const res = yield call(
    orderInvoicesServices.getPayeeLinkedEmployee,
    action.payload
  );

  if (res?.status && res?.data) {
    const orderInvoicesReducer = yield select(
      (state) => state?.orderInvoicesReducer
    );
    yield put(
      actions.saveOrderInvoicesValue({
        addEditPayeeData: {
          ...orderInvoicesReducer?.addEditPayeeData,
          ...makeAllObjToArr(res?.data),
        },
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getPayeeExpenseAccount(action) {
  const res = yield call(
    orderInvoicesServices.getPayeeExpenseAccount,
    action.payload
  );
  // const pageType = action.payload.type;
  if (res?.status && res?.data) {
    const orderInvoicesReducer = yield select(
      (state) => state?.orderInvoicesReducer
    );
    yield put(
      actions.saveOrderInvoicesValue({
        addEditPayeeData: {
          ...orderInvoicesReducer?.addEditPayeeData,
          expense_account: objToArr(res?.data?.expenses),
        },
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getPayeeContactStates(action) {
  const res = yield call(
    orderInvoicesServices.getPayeeContactStates,
    action.payload
  );
  const orderInvoicesReducer = yield select(
    (state) => state?.orderInvoicesReducer
  );
  // const formType = action.payload.formType;
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        addEditPayeeData: makeAllObjToArr({
          ...orderInvoicesReducer.addEditPayeeData,
          address_states: data?.states,
        }),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getPayeeBillingStates(action) {
  const res = yield call(
    orderInvoicesServices.getPayeeBillingStates,
    action.payload
  );
  const orderInvoicesReducer = yield select(
    (state) => state?.orderInvoicesReducer
  );
  // const formType = action.payload.formType;
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        addEditPayeeData: makeAllObjToArr({
          ...orderInvoicesReducer.addEditPayeeData,
          billing_states: data?.states,
        }),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getEditPayeeData(action) {
  const res = yield call(
    orderInvoicesServices.getEditPayeeData,
    action.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        addEditPayeeData: makeAllObjToArr(data, "payee"),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* postEditPayeeData(action) {
  const res = yield call(
    orderInvoicesServices.postEditPayeeData,
    action.payload.data
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    action.payload.history.push("/order/payees");
    actions?.showNotificationWithTimeout(res?.message ?? "", "success");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getPayeePaymentInfoData(action) {
  const res = yield call(orderInvoicesServices.getPayeePaymentInfoData);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        payeePaymentInfoData: makeAllObjToArr(data),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getPayeePaymentInfoOptions(action) {
  const res = yield call(
    orderInvoicesServices.getPayeePaymentInfoOptions,
    action.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        payeePaymentInfoOptions: makeAllObjToArr(data),
      })
    );
    // action.payload.history.push("/order/payees");
    actions?.showNotificationWithTimeout(res?.message ?? "", "success");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* postPayeePaymentInfoData(action) {
  const res = yield call(
    orderInvoicesServices.postPayeePaymentInfoData,
    action.payload
  );
  const orderInvoicesReducer = yield select(
    (state) => state?.orderInvoicesReducer
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        addEditPayeeData: {
          ...orderInvoicesReducer?.addEditPayeeData,
          payments_table: data?.payments,
        },
      })
    );
    yield put(
      actions.setModalState({
        modalName: "recurringPaymentsModal",
        modalState: false,
      })
    );
    // action.payload.history.push("/order/payees");
    actions?.showNotificationWithTimeout(res?.message ?? "", "success");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* postDeletePayeePaymentInfoData(action) {
  const res = yield call(
    orderInvoicesServices.postDeletePayeePaymentInfoData,
    action.payload
  );
  const orderInvoicesReducer = yield select(
    (state) => state?.orderInvoicesReducer
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    console.log(data, "datadata");
    yield put(
      actions.saveOrderInvoicesValue({
        addEditPayeeData: {
          ...orderInvoicesReducer?.addEditPayeeData,
          payments_table: data?.payments,
        },
      })
    );
    actions?.showNotificationWithTimeout(res?.message ?? "", "success");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getPayeeDocumentData(action) {
  const res = yield call(orderInvoicesServices.getPayeeDocumentData);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        payeeDocumentData: makeAllObjToArr(data),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* postPayeeDocumentData(action) {
  const res = yield call(
    orderInvoicesServices.postPayeeDocumentData,
    action.payload
  );
  const orderInvoicesReducer = yield select(
    (state) => state?.orderInvoicesReducer
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        addEditPayeeData: {
          ...orderInvoicesReducer?.addEditPayeeData,
          documents_table: data?.documents,
        },
      })
    );
    yield put(
      actions.setModalState({
        modalName: "payeeDocumentModal",
        modalState: false,
      })
    );
    actions?.showNotificationWithTimeout(res?.message ?? "", "success");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* deletePayeeDocumentData(action) {
  const res = yield call(
    orderInvoicesServices.deletePayeeDocumentData,
    action.payload
  );
  const orderInvoicesReducer = yield select(
    (state) => state?.orderInvoicesReducer
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    console.log(data, "datadata");
    yield put(
      actions.saveOrderInvoicesValue({
        addEditPayeeData: {
          ...orderInvoicesReducer?.addEditPayeeData,
          documents_table: data?.documents,
        },
      })
    );
    // action.payload.history.push("/order/payees");
    actions?.showNotificationWithTimeout(res?.message ?? "", "success");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getPayeeBankingInfoData(action) {
  const res = yield call(orderInvoicesServices.getPayeeBankingInfoData);
  if (res?.status && res?.data) {
    const data = res?.data;
    const orderInvoicesReducer = yield select(
      (state) => state?.orderInvoicesReducer
    );
    yield put(
      actions.saveOrderInvoicesValue({
        addEditPayeeData: {
          ...orderInvoicesReducer?.addEditPayeeData,
          employees_table: data?.employees,
        },
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* postPayeeBankingInfoData(action) {
  const res = yield call(
    orderInvoicesServices.postPayeeBankingInfoData,
    action.payload
  );
  const orderInvoicesReducer = yield select(
    (state) => state?.orderInvoicesReducer
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        payeeBankingInfoData: makeAllObjToArr(data),
      })
    );
    yield put(
      actions.saveOrderInvoicesValue({
        addEditPayeeData: {
          ...orderInvoicesReducer?.addEditPayeeData,
          employees_table: data?.employees,
        },
      })
    );
    yield put(
      actions.setModalState({
        modalName: "payeeBankingInfoModal",
        modalState: false,
      })
    );
    actions?.showNotificationWithTimeout(res?.message ?? "", "success");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* deletePayeeBankingInfoData(action) {
  const res = yield call(
    orderInvoicesServices.deletePayeeBankingInfoData,
    action.payload
  );
  const orderInvoicesReducer = yield select(
    (state) => state?.orderInvoicesReducer
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        addEditPayeeData: {
          ...orderInvoicesReducer?.addEditPayeeData,
          employees_table: data?.employees,
        },
      })
    );

    actions?.showNotificationWithTimeout(res?.message ?? "", "success");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* addPayeePendingApprovalData(action) {
  const res = yield call(
    orderInvoicesServices.addPayeePendingApprovalData,
    action.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        addPayeePendingApprovalData: data,
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* postPayeeStatus(action) {
  const res = yield call(orderInvoicesServices.postPayeeStatus, action.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        payeeList: data,
      })
    );

    actions?.showNotificationWithTimeout(res?.message ?? "", "success");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
// ar invoices
function* getArInvoicesData(action) {
  const res = yield call(
    orderInvoicesServices?.getArInvoicesData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        arInvoicesData: makeAllObjToArr(data),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getOutstandingArInvoicesData(action) {
  const res = yield call(
    orderInvoicesServices?.getOutstandingArInvoicesData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        outstandingArInvoicesData: makeAllObjToArr(data),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getCancelledArInvoicesData(action) {
  const res = yield call(
    orderInvoicesServices?.getCancelledArInvoicesData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        cancelledArInvoicesData: makeAllObjToArr(data),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getPaidArInvoicesData(action) {
  const res = yield call(
    orderInvoicesServices?.getPaidArInvoicesData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        paidArInvoicesData: makeAllObjToArr(data),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getNewArInvoicesOptions(action) {
  const res = yield call(
    orderInvoicesServices?.getNewArInvoicesOptions,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        newArInvoicesOptions: makeAllObjToArr(data),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* postArInvoicesData(action) {
  console.log(action, "actionactionactionaction");
  const res = yield call(
    orderInvoicesServices?.postArInvoicesData,
    action?.payload?.data
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        arInvoicesData: makeAllObjToArr(data),
      })
    );
    action.payload?.history.push("/order/ar-invoices");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getEditArInvoicesData(action) {
  console.log(action, "actionactionactionaction");
  const res = yield call(
    orderInvoicesServices?.getEditArInvoicesData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        editArInvoiceData: makeAllObjToArr(data, "ar_invoice"),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* postEditArInvoicesData(action) {
  console.log(action, "actionactionactionaction");
  const res = yield call(
    orderInvoicesServices?.postEditArInvoicesData,
    action?.payload?.data
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        arInvoicesData: makeAllObjToArr(data),
      })
    );
    action.payload?.history.push("/order/ar-invoices");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* postCancelArInvoice(action) {
  console.log(action, "actionactionactionaction");
  const res = yield call(
    orderInvoicesServices?.postCancelArInvoice,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        arInvoicesData: makeAllObjToArr(data),
      })
    );
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "success")
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getReceivablesList(action) {
  console.log(action, "actionactionactionaction");
  const res = yield call(
    orderInvoicesServices?.getReceivablesList,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        receivablesList: makeAllObjToArr(data),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getReceivableDetails(action) {
  console.log(action, "actionactionactionaction");
  const res = yield call(
    orderInvoicesServices?.getReceivableDetails,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        receivableDetails: makeAllObjToArr(data),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* postReceivePayments(action) {
  const res = yield call(
    orderInvoicesServices?.postReceivePayments,
    action?.payload?.data
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        receivableDetails: makeAllObjToArr(data),
      })
    );
    action?.payload?.setModalState(false);
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getCreditNoteList(action) {
  console.log(action, "actionactionactionaction");
  const res = yield call(
    orderInvoicesServices?.getCreditNoteList,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveOrderInvoicesValue({
        creditNoteList: makeAllObjToArr(data),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* orderInvoicesSaga() {
  // customers
  yield takeLatest(actionTypes.GET_CUSTOMERS_DATA, getCustomersData);
  yield takeLatest(actionTypes.POST_CUSTOMERS_DATA, postCustomersData);
  yield takeLatest(
    actionTypes.GET_DOWNLOAD_CUSTOMERS_DATA,
    getDownloadCustomersData
  );
  yield takeLatest(
    actionTypes.GET_CUSTOMERS_FORM_OPTIONS,
    getCustomersFormOptions
  );
  yield takeLatest(actionTypes.GET_CUSTOMER_EDIT_DATA, getCustomerEditData);
  yield takeLatest(
    actionTypes.GET_CUSTOMERS_FORM_CONTACT_STATES,
    getCustomersFormContactStates
  );
  yield takeLatest(
    actionTypes.GET_CUSTOMERS_FORM_BILLING_STATES,
    getCustomersFormBillingStates
  );
  yield takeLatest(actionTypes.POST_CUSTOMER_FILE, postCustomerFile);
  yield takeLatest(actionTypes.POST_CUSTOMER_EDIT_DATA, postCustomerEditData);

  // payees
  yield takeLatest(actionTypes.GET_PAYEE_LIST, getPayeeList);
  yield takeLatest(actionTypes.GET_DOWNLOAD_PAYEE_LIST, getDownloadPayeeList);
  yield takeLatest(actionTypes.POST_UPLOAD_PAYEE_LIST, postUploadPayeeList);
  yield takeLatest(actionTypes.GET_ADD_PAYEE_DATA, getAddPayeeData);
  yield takeLatest(actionTypes.POST_ADD_PAYEE_DATA, postAddPayeeData);
  yield takeLatest(
    actionTypes.GET_PAYEE_LINKED_EMPLOYEE,
    getPayeeLinkedEmployee
  );
  yield takeLatest(
    actionTypes.GET_PAYEE_EXPENSE_ACCOUNT,
    getPayeeExpenseAccount
  );

  yield takeLatest(actionTypes.GET_PAYEE_CONTACT_STATES, getPayeeContactStates);
  yield takeLatest(actionTypes.GET_PAYEE_BILLING_STATES, getPayeeBillingStates);
  yield takeLatest(actionTypes.GET_EDIT_PAYEE_DATA, getEditPayeeData);
  yield takeLatest(actionTypes.POST_EDIT_PAYEE_DATA, postEditPayeeData);
  yield takeLatest(
    actionTypes.GET_PAYEE_PAYMENT_INFO_OPTIONS,
    getPayeePaymentInfoOptions
  );
  yield takeLatest(
    actionTypes.POST_PAYEE_PAYMENT_INFO_DATA,
    postPayeePaymentInfoData
  );
  yield takeLatest(
    actionTypes.POST_DELETE_PAYEE_PAYMENT_INFO_DATA,
    postDeletePayeePaymentInfoData
  );
  yield takeLatest(
    actionTypes.GET_PAYEE_PAYMENT_INFO_DATA,
    getPayeePaymentInfoData
  );
  yield takeLatest(actionTypes.GET_PAYEE_DOCUMENT_DATA, getPayeeDocumentData);
  yield takeLatest(actionTypes.POST_PAYEE_DOCUMENT_DATA, postPayeeDocumentData);
  yield takeLatest(
    actionTypes.DELETE_PAYEE_DOCUMENT_DATA,
    deletePayeeDocumentData
  );

  yield takeLatest(
    actionTypes.GET_PAYEE_BANKING_INFO_DATA,
    getPayeeBankingInfoData
  );
  yield takeLatest(
    actionTypes.POST_PAYEE_BANKING_INFO_DATA,
    postPayeeBankingInfoData
  );
  yield takeLatest(
    actionTypes.DELETE_PAYEE_BANKING_INFO_DATA,
    deletePayeeBankingInfoData
  );

  yield takeLatest(
    actionTypes.ADD_PAYEE_PENDING_APPROVAL_DATA,
    addPayeePendingApprovalData
  );
  yield takeLatest(actionTypes.POST_PAYEE_STATUS, postPayeeStatus);

  // ar invoices
  yield takeLatest(actionTypes?.GET_AR_INVOICES_DATA, getArInvoicesData);
  yield takeLatest(
    actionTypes?.GET_OUTSTANDING_AR_INVOICES_DATA,
    getOutstandingArInvoicesData
  );
  yield takeLatest(
    actionTypes?.GET_CANCELLED_AR_INVOICES_DATA,
    getCancelledArInvoicesData
  );
  yield takeLatest(
    actionTypes?.GET_PAID_AR_INVOICES_DATA,
    getPaidArInvoicesData
  );
  yield takeLatest(
    actionTypes?.GET_NEW_AR_INVOICES_OPTIONS,
    getNewArInvoicesOptions
  );
  yield takeLatest(actionTypes?.POST_AR_INVOICES_DATA, postArInvoicesData);
  yield takeLatest(
    actionTypes?.GET_EDIT_AR_INVOICES_DATA,
    getEditArInvoicesData
  );
  yield takeLatest(
    actionTypes?.POST_EDIT_AR_INVOICES_DATA,
    postEditArInvoicesData
  );
  yield takeLatest(actionTypes?.POST_CANCEL_AR_INVOICE, postCancelArInvoice);

  // finance receivables
  yield takeLatest(actionTypes?.GET_RECEIVABLES_LIST, getReceivablesList);
  yield takeLatest(actionTypes?.GET_RECEIVABLE_DETAILS, getReceivableDetails);
  yield takeLatest(actionTypes?.POST_RECEIVE_PAYMENTS, postReceivePayments);
  yield takeLatest(actionTypes?.GET_CREDIT_NOTE_LIST, getCreditNoteList);
}

export default orderInvoicesSaga;
